import { render } from "./DiceDeveloper.vue?vue&type=template&id=9c6a6594"
import script from "./DiceDeveloper.vue?vue&type=script&lang=js"
export * from "./DiceDeveloper.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__